<template>
  <div class="tw-flex tw-gap-2 tw-items-center">
    <slot />
  </div>
</template>
